import { render, staticRenderFns } from "./IndexCategoriesPage.vue?vue&type=template&id=f7a1f924&"
import script from "./IndexCategoriesPage.vue?vue&type=script&lang=js&"
export * from "./IndexCategoriesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports